import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAzurefunctionsComponent } from './simple-icons-azurefunctions.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAzurefunctionsComponent ],
    exports:      [ SimpleIconsAzurefunctionsComponent ],
    bootstrap:    []
})
export class SimpleIconsAzurefunctionsModule {}
